import React from "react";

function FamilyHistory() {
  return (
    <div>
      <div className="card h-[370px] w-[370px] m-5 border rounded-lg">
        <div className="header h-[13%] bg-[#B5FFD2] flex items-center justify-center rounded p-2">
          <h1 className="font-bold text-normal text-[#0a2e18] mt-3">
            Family History
          </h1>
        </div>
        <div className="body h-[75%] overflow-y-auto scrollwidth bg-white border-t-2 border-t-[#14BC57]">
          <div className="items-center text-sm p-2 m-3 border rounded-md">
            <div className="font-semibold">
              Family History:
              <span className="font-medium text-gray-500">
                {" "}
                Grandmother with CVD
              </span>
            </div>
            <div className="ml-auto font-medium mt-2 flex justify-start">
              <h5 className="text-gray-500 font-semibold text-sm">
                Onset date: <span>2024-12-21</span>
              </h5>
            </div>
          </div>
          <div className="items-center text-sm p-2 m-3 border rounded-md">
            <div className="font-semibold">
              Family History:
              <span className="font-medium text-gray-500">
                {" "}
                Father with DM
              </span>
            </div>
            <div className="ml-auto font-medium mt-2 flex justify-start">
              <h5 className="text-gray-500 font-semibold text-sm">
                Onset date: <span>2024-12-21</span>
              </h5>
            </div>
          </div>
          <div className="items-center text-sm p-2 m-3 border rounded-md">
            <div className="font-semibold">
              Family History:
              <span className="font-medium text-gray-500">
                {" "}
                allergy
              </span>
            </div>
            <div className="ml-auto font-medium mt-2 flex justify-start">
              <h5 className="text-gray-500 font-semibold text-sm">
                Onset date: <span>2024-12-21</span>
              </h5>
            </div>
          </div>
          <div className="items-center text-sm p-2 m-3 border rounded-md">
            <div className="font-semibold">
              Family History:
              <span className="font-medium text-gray-500">
                {" "}
              normal
              </span>
            </div>
            <div className="ml-auto font-medium mt-2 flex justify-start">
              <h5 className="text-gray-500 font-semibold text-sm">
                Onset date: <span>2024-12-21</span>
              </h5>
            </div>
          </div>
        </div>
        <div className="footer h-[44px] bg-[#B5FFD2] rounded"></div>
      </div>
    </div>
  );
}

export default FamilyHistory;
